(function ($) {
    $.fn.listArticle = function (settings) {
        // pokud neni div#ads-iframe, vloz ho
        if ($('#ads-iframe').length === 0) {
            $('body').append('<div id="ads-iframe" />');
        }

        let listIt = 1;
        var options = {
                paging: 0,
                pagingBy: 5,
                fadeIn: 500,
                fadeOut: 100,
                magazine: 'blesk',
                forcepaging: 0,
                showRecentArticles: true,
            },
            settings = settings,
            $that = $(this),
            chapterIds = [];
        options = $.extend(options, settings);
        if (options.paging == 1) {
            var paging = {
                // aktivní skupina paging odkazů
                firstVisibleAnchorIndexOfChapters: null,
                lastVisibleAnchorIndexOfChapters: null,
                inProgress: 0,
                style: null,
            };
        }
        if (typeof $.cookie('newuser') !== 'undefined') {
            if ($.cookie('newuser') == 1 || options.forcepaging == 1) {
                listIt = 1;
            }
        } else {
            listIt = 1;
        }

        if (listIt == 1) {
            $that.find('.inner_7').removeClass('inner_7').addClass('inner_8');
            // sirka clanku
            let gridWidth,
                // padding jednotlivých li
                padding;
            // if(options.magazine == "isport") gridWidth = $that.find("[class^='grid_8']").width();
            // else if(options.magazine == "blesk") gridWidth = $that.find("#article").width();
            // else gridWidth = $that.find("[class^='inner_']").width()
            gridWidth = $that.find('#article').width() - 20;
            switch (options.paging) {
                case 0:
                    padding = 0;
                    break;
                default:
                    padding = 10;
            }

            // načtení hashe
            hash = getHash();

            $that.find('.notlisted').removeClass('notlisted').addClass('listed');
            $that
                .find('ul.main')
                .addClass('listed')
                .css('display', 'block')
                .children('li')
                .each(function (i) {
                    if (options.paging == 0) {
                        if (i == 0) {
                            $(this).find('h1, .leadsection').css('margin-left', '80px');
                        }
                        if (i >= 1) {
                            chapterIds.push($(this).data('id'));
                        }
                    } else {
                        if (i == 0) {
                            $(this).attr('data-id', 'intro');
                            chapterIds.push($(this).data('id'));
                        }
                        if (i >= 1) {
                            chapterIds.push($(this).data('id'));
                        }
                    }

                    if (!hash) {
                        if (i === 0) {
                            $(this).addClass('active');
                        }
                    } else {
                        $(`li[data-id=${hash.replace('#', '')}]`).addClass('active');
                        buttonsControl($(`li[data-id=${hash.replace('#', '')}]`));
                    }
                    $(this).removeClass('pseudoInner_7');
                    if ($(this).attr('id') !== 'related') {
                        $(this).css('width', '610px').css('margin', '0 auto').css('float', 'none');
                    }
                });
            if (settings.paging === 0) {
                (controlsButtons = $that.find('.listingControlButtons')),
                    (smallControlButtons = controlsButtons.clone());
                // smallControlButtons.addClass("smallControlButtons").css("display", "block").find(".counter").remove();
                smallControlButtons.attr('id', `${smallControlButtons.attr('id')}-clone`);

                $(smallControlButtons).prependTo('.bottom');
            } else {
                $that.find('ul.listed').before("<div class='paging' style='min-width:100%'/>");
                $that.find('ul.listed').after("<div class='paging' style='min-width:100%'/>");

                $that
                    .find('.paging')
                    .append(
                        "<button class='prev showPrev'><div class='pagingPrevArrow'></div>Předchozí</button><div class='pagingHolder'></div><button class='next showNext'>Další<div class='pagingNextArrow'></div></button>",
                    );
                $that.find('.paging').after("<div class='clearfix' />");
                $that.find('.paging').append("<div class='clearfix' />");
                const pagingPosition = $that.find('.paging .pagingHolder');

                for (var i = 0; i <= chapterIds.length - 1; i++) {
                    if (i == 0) {
                        name = 'úvod';
                        id = chapterIds[i];
                    } else if (i == chapterIds.length - 1) {
                        if (
                            $that.find(`ul.listed > li:nth-child(${i + 1})`).data('id') == 'related'
                        ) {
                            name = 'více';
                        } else {
                            name = i;
                        }
                        id = chapterIds[i];
                    } else {
                        name = i;
                        id = chapterIds[i];
                    }
                    pagingPosition.append(`<a href='#' data-id=${id}>${name}</a>`);
                }

                if (settings.paging === 1) controlPagingElements();
            }

            $(document).ready(() => {
                console.log('\n\n', options, '\n\n');

                const socialShares = $that.find('.socialShares').clone();
                $that.find('.socialShares').hide();
                $that.find('ul.listed li:first-child .articleDetails').append(socialShares);
                $that
                    .find('ul.listed li:first-child .articleDetails .socialShares')
                    .css('margin-left', '80px');
                socialShares.css('margin-left', 0);
                $that.find('.bottom .clearfix').before(socialShares);
                if ($that.find('ul.listed li:first-child').hasClass('active')) {
                    $that.find('.bottom .socialShares').hide();
                    $that.find('.articleDetails .socialShares').show();
                }
                $('.bottom .socialShares:eq(1)').hide();
            });

            const related = $that.find('ul.listed li#related').length;

            $that.find('.socialMedia').hide();
            $that.find('.bottom .authors:not(.autorLeft)').css('margin-left', '80px');
            $that.find('.leadsection p').css('font-weight', 'bold');
            if (related === 1)
                $that.find('.listingControlButtons .totalNumber').html(chapterIds.length - 1);
            else $that.find('.listingControlButtons .totalNumber').html(chapterIds.length);
            $that.find('.listingControlButtons').css('display', 'block');
            buttonsControl($that.find('ul.listed > li.active'));
            $that.find('.listingControlButtons button, .paging button').click(function () {
                buttonPressed($(this));
            });
            $that.find('.paging a[data-id]').click(function (e) {
                e.preventDefault();
                paging.oldItem = $that.find('ul.listed > li.active');
                paging.newItem = $that.find(`ul.listed li[data-id="${$(this).data('id')}"]`);
                $that.find('.paging a.active').each(function () {
                    $(this).removeClass('active');
                });

                hideAndShowNext(paging.oldItem, paging.newItem);
            });
        } else if (options.magazine === 'blesk') {
            $that.find('li#related').hide();
        }
        // getter for hash
        function getHash() {
            return window.location.hash;
        }
        // keypress navigation
        $('body').keydown((e) => {
            e.stopImmediatePropagation();

            if (e.keyCode == 37) {
                // left
                var activeId = $that.find('ul.listed > li.active').data('id');
                if (options.paging == 0) {
                    if (chapterIds.indexOf(activeId) >= 0)
                        buttonPressed($that.find('.listingControlButtons button.prev'));
                } else if (chapterIds.indexOf(activeId) > 0)
                    buttonPressed($that.find('.listingControlButtons button.prev'));
            } else if (e.keyCode == 39) {
                // right
                var activeId = $that.find('ul.listed > li.active').data('id');
                if (chapterIds.indexOf(activeId) + 1 < chapterIds.length)
                    buttonPressed($that.find('.listingControlButtons button.next'));
            }
        });

        // GTM 2.0 | Google Analytics: Apps + Web
        let gtmPage =
            1 + Number($('li.active > div.headerWrapper > div.number').text().replace('.', ''));

        function buttonPressed(button) {
            let cls = button.attr('class'),
                oldItem = $that.find('ul > li.active'),
                dir,
                newItem;

            if (cls.search('showStart') != -1) {
                dir = 'showStart';

                // GTM 2.0 | Google Analytics: Apps + Web
                gtmPage = 1;
                dataLayer.push({
                    event: 'articlePart_previous',
                    article: { part: gtmPage },
                });
            } else if (cls.search('showNext') != -1) {
                dir = 'next';

                // GTM 2.0 | Google Analytics: Apps + Web
                gtmPage += 1;
                dataLayer.push({
                    event: 'articlePart_next',
                    article: { part: gtmPage },
                });
            } else if (cls.search('showPrev') != -1) {
                dir = 'prev';

                // GTM 2.0 | Google Analytics: Apps + Web
                gtmPage -= 1;
                dataLayer.push({
                    event: 'articlePart_previous',
                    article: { part: gtmPage },
                });
            } else dir = 'error';
            switch (dir) {
                case 'next':
                    // nextAll/prevAll: mezi kapitolami mohou být cizí elementy
                    newItem = oldItem.nextAll('li').first();
                    break;
                case 'prev':
                    newItem = oldItem.prevAll('li').first();
                    break;
                case 'showStart':
                    newItem = $that.find('ul > li:first-child');

                    break;
                case 'error':
                    newItem = 'error';
                    break;
            }
            hideAndShowNext(oldItem, newItem);

            // Marfeel | PV - vypnutí trackování pro listování v článku
            window.marfeel = window.marfeel || { cmd: [] };
            window.marfeel.cmd.push([
                'compass',
                function (compass) {
                    compass.trackNewPage();
                },
            ]);
        }
        buttonsControl($that.find('#article ul.main > li.active'));
        function hideAndShowNext(oldItem, newItem) {
            var oldItem = oldItem,
                newItem = newItem,
                goToNext = 1;
            if (options.paging === 1) paging.inProgress = 1;
            if (options.magazine == 'blesk') {
                scrollToArticleTop();
            }
            if (newItem != 'error') {
                $that.find('ul.listed li.active').removeClass('active');
                oldItem.fadeOut(options.fadeOut, () => {
                    oldItem.removeClass('active');
                    buttonsControl(newItem);
                    newItem
                        .addClass('active')
                        .hide()
                        .fadeIn(options.fadeIn, () => {
                            if (options.paging === 1) {
                                paging.inProgress = 0;
                                applyPagingStyle(
                                    calculateActivePagingStyle(
                                        chapterIds.indexOf(newItem.data('id')),
                                    ),
                                );
                            }

                            hashControl(newItem.data('id'));
                        });
                });
                if (options.paging === 1) {
                    $('.paging a.active').removeClass('active');
                    hashControl(newItem.data('id'));
                    paging.pagingDiv.find(`a[data-id="${newItem.data('id')}"]`).addClass('active');

                    controlPagingElements();
                }
            }

            if (newItem != 'error') {
                hashControl(newItem.data('id'));
            }

            // nastavit hodnoty GA pro listovani
            const pagePath = location.pathname + window.location.search;
            const pageTitle = document.title;
            dataLayer.push({ event: 'ga.pageview', pagePath, pageTitle });

            // obnovit reklamu
            if (typeof window.__cncAdsReload !== 'undefined') {
                window.__cncAdsQueue = window.__cncAdsQueue || [];
                window.__cncAdsQueue.push(() => {
                    window.__cncAdsReload();
                });
            }
        }

        function buttonsControl(newItem) {
            var buttons = $that.find('.listingControlButtons'),
                newItem = newItem,
                itemId = newItem.data('id');
            if (!itemId || itemId == 'intro') {
                buttons.find('button.prev, button.next, .counter, .showStart').hide();
                buttons.find('button.moreArticles').hide();

                $that.find('.authors').show();
                if (settings.paging == 1) {
                    $that.find('.paging .showPrev').removeClass('showPrev');
                }
                // harakiri-hack: hiding social buttons
                $that.find('.bottom .socialShares').hide();
                $that.find('.authors').show();
                buttons.find('button.startListing').show();
                $that.find('.smallControlButtons').show();
            } else if (chapterIds.indexOf(itemId) == 0) {
                $that
                    .find(
                        '.listingControlButtons .moreArticles, .listingControlButtons .startListing, .listingControlButtons .showStart',
                    )
                    .hide();
                $that
                    .find(
                        '.listingControlButtons .prev, .listingControlButtons .next:not(".moreArticles"), .listingControlButtons .counter',
                    )
                    .show();
                $that.find('.bottom .socialShares').css('margin-left', 0).show();
                buttons.find('.counter').show();
                $that.find('.smallControlButtons, .bottom').show();
                $that.find('.bottom .authors').hide();
            } else if (chapterIds.indexOf(itemId) == 1) {
                $that
                    .find(
                        '.listingControlButtons .moreArticles, .listingControlButtons .startListing, .listingControlButtons .showStart',
                    )
                    .hide();

                $that
                    .find(
                        '.listingControlButtons .prev, .listingControlButtons .next:not(".moreArticles"), .counter',
                    )
                    .show();
            } else if (
                (chapterIds.indexOf(itemId) != -1 &&
                    chapterIds.indexOf(itemId) + 1 < chapterIds.length &&
                    options.magazine !== 'blesk') ||
                (chapterIds.indexOf(itemId) != -1 &&
                    chapterIds.indexOf(itemId) < chapterIds.length - 1)
            ) {
                buttons.find('.showStart, .startListing').hide();
                buttons.find('button.prev, button.next, .counter').show();
                buttons.find('.moreArticles').hide();
                $that.find('.bottom .socialShares').css('margin-left', 0).show();
                $that.find('.bottom .authors').hide();

                if (chapterIds.indexOf(itemId) === 0) {
                    buttons.find('.showPrev').addClass('showStart');
                    buttons.find('.moreArticles').hide();
                } else if (chapterIds.indexOf(itemId) > 0) {
                    buttons.find('.showPrev').removeClass('showStart');
                }
                if (options.paging == 1) {
                    const next = $that.find('.paging button.next'),
                        prev = $that.find('.paging button.prev');

                    if (next.hasClass('showNext') == false) next.addClass('showNext');
                    if (prev.hasClass('showPrev') == false) prev.addClass('showPrev');
                }
                // harakiri-hack: showing social buttons, hiding authors
                $that.find('.bottom .socialShares').css('margin-left', 0).show();
                $that.find('.bottom .authors').hide();
            } else if (
                chapterIds.indexOf(itemId) == chapterIds.length - 2 &&
                options.showRecentArticles == true
            ) {
                // předposlední pouze blesk

                buttons.find('.next').hide();
                buttons.find('.moreArticles').show();
                buttons.find('.counter').hide();
            } else if (
                chapterIds.indexOf(itemId) + 1 == chapterIds.length ||
                (chapterIds.indexOf(itemId) == chapterIds.length - 2 &&
                    options.showRecentArticles == false)
            ) {
                buttons.find('.counter').hide();
                buttons.find('button.next, button.startListing').hide();
                buttons.find('button.showStart').show();
                buttons.find('button.prev').removeClass('showStart');
                buttons.find('.moreArticles').hide();

                if (settings.paging == 1) {
                    $that.find('.paging .showNext').removeClass('showNext');
                }
                buttons.find('button.next').hide();
                buttons.find('button.prev').hide();
                buttons.find('button.showStart').hide();
                $('.bottom').removeAttr('style');
                buttons.find('.counter').hide();
                buttons.find('.moreArticles').hide();
                buttons.find('button.showStart').show();
            }

            counterControl(chapterIds.indexOf(itemId) + 1);

            if (!itemId || itemId == 'intro') {
                $that.find('.bottom').show();
                $('#listingControlButtons').hide();
                $('#listingControlButtons-clone').removeClass('smallControlButtons');
                $('.main.listed').css('border-top', '0px solid #cad5df');
            } else {
                $('#listingControlButtons').show();
                $('#listingControlButtons-clone').css('display', 'block');
                $('#listingControlButtons-clone').addClass('smallControlButtons');
                $('.main.listed').removeAttr('style').css('display', 'block');
            }

            $('.bottom .socialShares:eq(1)').hide();
        }

        function counterControl(position) {
            var position = position;
            if (
                position > 0 &&
                chapterIds.indexOf(position) <= chapterIds.length &&
                options.paging == 0
            ) {
                $that.find('.counter .actualNumber').html(position);
            }
        }

        function hashControl(id) {
            var id = id;
            if (id && id != 'intro') {
                window.history.pushState(null, null, `#${id}`);
            } else {
                history.pushState(
                    '',
                    document.title,
                    window.location.pathname + window.location.search,
                );
            }
        }

        function controlPagingElements() {
            const hash = getHash();
            if (hash && paging.inProgress === 0) {
                $that.find(`.paging a[data-id="${hash.replace('#', '')}"]`).addClass('active');
            }

            let activeAnchor = $that.find('.paging a.active');
            if (options.paging === 1) paging.pagingDiv = $that.find('.paging');

            // if no active paging anchor, make the "intro" one active!
            if (paging.inProgress === 0) {
                if (!activeAnchor.length) {
                    activeAnchor = $that.find('.paging a[data-id="intro"]').addClass('active');
                }
            }
            controlPagingButtons(activeAnchor);
            if (options.paging === 1) paging.inProgress = 0;
        }

        function controlPagingButtons(activeAnchor) {
            var { pagingDiv } = paging,
                { pagingBy } = options,
                showPagingSystem,
                activeAnchor = activeAnchor.data('id'),
                activeAnchorIndexOfChapters = chapterIds.indexOf(activeAnchor);
            // set showPagingSystem - threeDots
            if (chapterIds.length <= pagingBy || chapterIds.length <= 12) {
                paging.showPagingSystem = false;
            } else {
                paging.showPagingSystem = true;
            }
            // hashControl(activeAnchor);
            if (paging.showPagingSystem == true) {
                threeDots = $('<a href="#" class="threeDots" style="cursor: default;">...</a>');
                $that.find('.pagingHolder').addClass('centered');
                // put threeDots in place
                if (paging.pagingDiv.find('a.next').length <= 0) {
                    paging.pagingDiv.find('.pagingHolder a:first-child').before(
                        threeDots
                            .clone()
                            .addClass('prev')
                            .attr('data-moveto', 'prev')
                            .bind('click', (e) => {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                // switchPaging($(this))
                            }),
                    );
                    paging.pagingDiv.find('.pagingHolder a:last-of-type').after(
                        threeDots
                            .clone()
                            .addClass('next')
                            .attr('data-moveto', 'next')
                            .bind('click', (e) => {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                // switchPaging($(this))
                            }),
                    );
                }

                paging.pagingDiv.find('a.next').hide();
                paging.pagingDiv.find('a.prev').hide();
                applyPagingStyle(calculateActivePagingStyle(activeAnchorIndexOfChapters));
            }
        }

        function calculateActivePagingStyle(activeAnchorIndexOfChapters) {
            // output as "fromStart"/"almostStart"/"between"/"almostEnd"/"toEnd"
            console.console.log(activeAnchorIndexOfChapters);
            let style,
                { pagingBy } = options,
                activeIndex = activeAnchorIndexOfChapters;
            if (activeIndex == pagingBy - 1) {
                style = 'almostStart';
            } else if (activeIndex <= pagingBy - 2) {
                style = 'fromStart';
            } else if (chapterIds.length - pagingBy == activeIndex) {
                style = 'almostEnd';
            } else if (chapterIds.length - pagingBy <= activeIndex) {
                style = 'toEnd';
            } else {
                style = 'between';
            }
            return style;
        }

        function applyPagingStyle(style) {
            var style = style;
            if (settings.paging === 1) pagingDiv = paging.pagingDiv;
            if (paging.showPagingSystem == true) {
                switch (style) {
                    case 'fromStart':
                        pagingDiv.find('a').hide();
                        for (i = 0; i <= options.pagingBy - 1; i++) {
                            pagingDiv.find(`a[data-id="${chapterIds[i]}"]`).show();
                        }
                        pagingDiv.find('a.next').show();
                        pagingDiv.find('a.prev').hide();
                        break;
                    case 'almostStart':
                        pagingDiv.find('a').hide();
                        for (i = 1; i <= options.pagingBy; i++) {
                            pagingDiv.find(`a[data-id="${chapterIds[i + 1]}"]`).show();
                        }
                        pagingDiv.find('a.next').show();
                        pagingDiv.find('a.prev').show();
                        break;
                    case 'between':
                        pagingDiv.find('a').hide();
                        var active = pagingDiv.find('a.active'),
                            offset = Math.floor(options.pagingBy / 2),
                            activeId = active.data('id');
                        if (offset % 2 != 0) offset -= 1;
                        active.show();
                        for (i = 1; i <= options.pagingBy; i++) {
                            pagingDiv
                                .find(
                                    `a[data-id="${
                                        chapterIds[chapterIds.indexOf(activeId) + i - offset - 1]
                                    }"]`,
                                )
                                .show();
                        }
                        pagingDiv.find('a.next').show();
                        pagingDiv.find('a.prev').show();
                        break;
                    case 'almostEnd':
                        pagingDiv.find('a').hide();
                        for (
                            i = chapterIds.length - 1;
                            i > chapterIds.length - 1 - options.pagingBy;
                            i--
                        ) {
                            pagingDiv.find(`a[data-id="${chapterIds[i - 2]}"]`).show();
                        }

                        pagingDiv.find('a.prev').show();
                        pagingDiv.find('a.next').show();
                        break;
                    case 'toEnd':
                        pagingDiv.find('a').hide();
                        for (
                            i = chapterIds.length - 1;
                            i > chapterIds.length - 1 - options.pagingBy;
                            i--
                        ) {
                            pagingDiv.find(`a[data-id="${chapterIds[i]}"]`).show();
                        }
                        pagingDiv.find('a.next').hide();
                        pagingDiv.find('a.prev').show();
                        break;
                }
                centerPaging();
            }
        }
        function switchPaging(element) {
            (moveto = element.data('moveto')), (paging.inProgress = 1);
            paging.moveto = moveto;
            paging.lastVisibleAnchorIndexOfChapters = chapterIds.indexOf(
                paging.pagingDiv.find('a:visible:not(".threeDots"):last').data('id'),
            );
            paging.firstVisibleAnchorIndexOfChapters = chapterIds.indexOf(
                paging.pagingDiv.find('a:visible:not(".threeDots"):first').data('id'),
            );
            paging.pagingDiv.find('a').hide();
            switch (moveto) {
                case 'next':
                    for (i = 1; i <= options.pagingBy; i++) {
                        paging.pagingDiv
                            .find(
                                `a[data-id="${
                                    chapterIds[paging.lastVisibleAnchorIndexOfChapters + i]
                                }"]`,
                            )
                            .show();
                    }
                    if (
                        chapterIds.indexOf(paging.pagingDiv.find('a:visible:last').data('id')) <
                        chapterIds.length - 1
                    ) {
                        paging.pagingDiv.find('a.next').show();
                    }

                    paging.pagingDiv.find('a.prev').show();
                    break;
                case 'prev':
                    paging.pagingDiv.find('a').hide();
                    for (i = 1; i <= options.pagingBy; i++) {
                        paging.pagingDiv
                            .find(
                                `a[data-id="${
                                    chapterIds[paging.firstVisibleAnchorIndexOfChapters - i]
                                }"]`,
                            )
                            .show();
                    }
                    if (
                        chapterIds.indexOf(paging.pagingDiv.find('a:visible:first').data('id')) > 0
                    ) {
                        paging.pagingDiv.find('a.prev').show();
                    }

                    paging.pagingDiv.find('a.next').show();
                    break;
            }
            paging.firstVisibleAnchorIndexOfChapters = null;
            paging.lastVisibleAnchorIndexOfChapters = null;
        }
        // BPZ
        function showIntro() {
            $('articleContent > h1').removeAttr('style').css({
                color: 'black',
                'text-decoration': 'none',
                cursor: 'normal',
            });
            $('articleContent > h1').removeAttr('style').unbind('mouseover');
            const oldItem = $('ul.listed > li.active'),
                newItem = $('ul.listed > li:first-child');
            hideAndShowNext(oldItem, newItem);
        }
        function centerPaging() {
            let anchorsWidth, pagingDivWidth, buttonsWidth;
            $that
                .find('.pagingHolder:first-of-type a')
                .filter("[style='display: block']")
                .each(function () {
                    anchorsWidth += $(this).width();
                });
        }

        function scrollToArticleTop() {
            const offset = $that.find('#article').offset().top;
            $(window).scrollTop(offset - 10);
        }

        return this;
    };
})(jQuery);
